<template>
  <div id="app">
    <router-view />
    <div class="lang-switch">
      <label class="lang-label" for="locale-selector">{{ $t("global.language") }}</label>
      <select id="locale-selector" v-model="currentLocale" @change="onLocaleChange">
        <option v-for="option in languageOptions" :key="option.value" :value="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>
    <div class="bottom_logo" v-if="showBottomLogo">
      <div>Powered By</div>
      <van-image width="100" :src="logo" />
    </div>
    <van-overlay :show="!onLine">
      <van-empty image="network" :description="$t('global.networkerror')" />
    </van-overlay>
  </div>
</template>
<script>
/**
 * Starter page component
 */
import { normalizeLocale } from "@/utils/locale";

export default {
  data() {
    return {
      logo: "",
      onLine: navigator.onLine,
      currentLocale: "en-us",
      languageOptions: [
        { value: "en-us", label: "English" },
        { value: "zh-cn", label: "简体中文" },
        { value: "zh-hk", label: "繁體中文(HK)" },
        { value: "zh-mo", label: "繁體中文(MO)" },
        { value: "zh-tw", label: "繁體中文(TW)" },
        { value: "ja-jp", label: "日本語" },
      ],
    };
  },
  mounted() {
    this.logo = require("@/assets/logo.png");
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
    // document.title = "收银台 - 激萌云物联啤酒机"

    const savedLanguage = localStorage.getItem("locale");
    const clientLanguage = navigator.language || navigator.userLanguage;
    this.applyLocale(savedLanguage || clientLanguage);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  },
  watch: {
    "$i18n.locale"(value) {
      this.currentLocale = value;
      this.loadingdata();
    },
  },
  computed: {
    showBottomLogo() {
      const hiddenOnRoutes = ["detail", "cashier", "success"];
      return !hiddenOnRoutes.includes(this.$route.name);
    },
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    },
    loadingdata() {
      document.title = this.$t("title");
    },
    onLocaleChange() {
      this.applyLocale(this.currentLocale);
    },
    applyLocale(locale) {
      const normalizedLocale = normalizeLocale(locale);
      this.currentLocale = normalizedLocale;
      this.$i18n.locale = normalizedLocale;
      localStorage.setItem("locale", normalizedLocale);
      this.loadingdata();
    },
  },
};
</script>
<style>
.bottom_logo {
  width: 100%;
  position: fixed;
  z-index: 20;
  pointer-events: none;
  bottom: calc(56px + env(safe-area-inset-bottom) + 8px);
  text-align: center;
  filter: Gray;
  -webkit-filter: grayscale(100%);
  opacity: 0.85;
}
.bottom_logo div {
  margin-bottom: 5px;
  color: gray;
}
.lang-switch {
  position: fixed;
  top: 8px;
  right: 8px;
  z-index: 1000;
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.92);
}
.lang-label {
  margin-right: 6px;
  font-size: 12px;
  color: #333;
}
.lang-switch select {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 4px;
}
.van-overlay .van-empty{
  margin-top: 50%;
}
</style>